import { getSelectedBusinessData } from "selectors/businesses";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import BusinessesActions from "actions/BusinessesActions";
import DocumentPaymentTypes from "const/DocumentPaymentTypes";
import DocumentsActions from "actions/DocumentsActions";
import TransactionTypes from "const/TransactionTypes";

const useAttachDocument = ({ id: transactionId, documentId, type }) => {
  const dispatch = useDispatch();

  const {
    settings: { advancedDocumentsWorkflow } = {}
  } = useSelector(getSelectedBusinessData);

  return useCallback(async(file) => {
    if (!advancedDocumentsWorkflow) return false;
    if (documentId) await dispatch(BusinessesActions.unpairMatches(transactionId, documentId, false, true));

    const result = await dispatch(DocumentsActions.uploadDocuments([file],
      { paymentType: type === TransactionTypes.WITHDRAW ? DocumentPaymentTypes.BUY : DocumentPaymentTypes.SELL }));

    if (result) {
      const [newDocument] = result;

      if (newDocument) {
        await dispatch(BusinessesActions.pairMatches(transactionId, newDocument.id, false, true));

        return newDocument;
      }
    }

    return false;
  }, [advancedDocumentsWorkflow, dispatch, documentId, transactionId, type]);
};

export default useAttachDocument;
